/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIPartEstimatedPrice
 */
export interface APIPartEstimatedPrice {
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPrice
     */
    estimatedPrice?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPrice
     */
    estimatedInvestmentCost?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPrice
     */
    estimatedMaterialCost?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPrice
     */
    estimatedManufacturingCost?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPrice
     */
    estimatedTreatmentCost?: string;
}

/**
 * Check if a given object implements the APIPartEstimatedPrice interface.
 */
export function instanceOfAPIPartEstimatedPrice(value: object): value is APIPartEstimatedPrice {
    return true;
}

export function APIPartEstimatedPriceFromJSON(json: any): APIPartEstimatedPrice {
    return APIPartEstimatedPriceFromJSONTyped(json, false);
}

export function APIPartEstimatedPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartEstimatedPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'estimatedPrice': json['estimated_price'] == null ? undefined : json['estimated_price'],
        'estimatedInvestmentCost': json['estimated_investment_cost'] == null ? undefined : json['estimated_investment_cost'],
        'estimatedMaterialCost': json['estimated_material_cost'] == null ? undefined : json['estimated_material_cost'],
        'estimatedManufacturingCost': json['estimated_manufacturing_cost'] == null ? undefined : json['estimated_manufacturing_cost'],
        'estimatedTreatmentCost': json['estimated_treatment_cost'] == null ? undefined : json['estimated_treatment_cost'],
    };
}

export function APIPartEstimatedPriceToJSON(value?: APIPartEstimatedPrice | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'estimated_price': value['estimatedPrice'],
        'estimated_investment_cost': value['estimatedInvestmentCost'],
        'estimated_material_cost': value['estimatedMaterialCost'],
        'estimated_manufacturing_cost': value['estimatedManufacturingCost'],
        'estimated_treatment_cost': value['estimatedTreatmentCost'],
    };
}

